import "./App.css";
import "./i18n";
import {
    BrowserRouter as Router,
    Route,
    Link,
    Routes,
    Navigate,
} from "react-router-dom";

import WhatsAppWidget from "react-whatsapp-widget";
import "react-whatsapp-widget/dist/index.css";

import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";

import fbIcon from "./assets/icons/fb-icon.svg";
import igIcon from "./assets/icons/ig-icon.svg";
import twIcon from "./assets/icons/tw-icon.svg";
import ytIcon from "./assets/icons/yt-icon.svg";

import LAdminFC from "./assets/img/logo-admin-finques-colegiat.png";
import LEconoCat from "./assets/img/logo-economistes-cat.png";
import LApi from "./assets/img/logo-api.png";
import Logo from "./assets/img/logo-ra.png";
import BurgerMenuIcon from "./assets/icons/burger-menu-icon.svg";

import Footer from "./components/Footer";
import { useState } from "react";

import ProtectedRoutes from "./ProtectedRoutes";
import Sidebar from "./components/Sidebar";
import { useTranslation } from "react-i18next";

import { useRef } from "react";

import { useEffect } from "react";
import ReactGA from "react-ga4";

//Import Pages sin lazy loading
import Home from "./pages/Home/Home";
import Inmuebles from "./pages/Inmuebles/Inmuebles";
import DetallesInmb from "./pages/DetallesInmb/DetallesInmb";
import VenderPage from "./pages/VenderPage/VenderPage";
import Login from "./pages/Login/Login";
import AvisLegal from "./pages/AvisLegal/AvisLegal";
import PoliticaPrivacidad from "./pages/PoliticaPrivacidad/PoliticaPrivacidad";
import PoliticaCookies from "./pages/PoliticaCookies/PoliticaCookies";
import Menu from "./pages/Menu/Menu";
import DashboardInmb from "./pages/DashboardInmb/DashboardInmb";
import AddInmueble from "./pages/AddInmueble/AddInmueble";
import EditInmueble from "./pages/EditInmueble/EditInmueble";
import Blog from "./pages/Blog/Blog";
import Articulo from "./pages/Articulo/Articulo";
import Servicios from "./pages/Servicios/Servicios";
import {
    CONSENT_COOKIE,
    acceptCookies,
    declineCookies,
} from "./utils/cookies-management";

// // Import pages lazy loading (testing...)
// const Home = lazy(() => import('./pages/Home/Home'));
// const Inmuebles = lazy(() => import('./pages/Inmuebles/Inmuebles'));
// const DetallesInmb = lazy(() => import('./pages/DetallesInmb/DetallesInmb'));
// const VenderPage = lazy(() => import('./pages/VenderPage/VenderPage'));
// const Login = lazy(() => import('./pages/Login/Login'));
// const AvisLegal = lazy(() => import('./pages/AvisLegal/AvisLegal'));
// const PoliticaPrivacidad = lazy(() => import('./pages/PoliticaPrivacidad/PoliticaPrivacidad'));
// const PoliticaCookies = lazy(() => import('./pages/PoliticaCookies/PoliticaCookies'));
// const Menu = lazy(() => import('./pages/Menu/Menu'));
// const DashboardInmb = lazy(() => import('./pages/DashboardInmb/DashboardInmb'));
// const AddInmueble = lazy(() => import('./pages/AddInmueble/AddInmueble'));
// const EditInmueble = lazy(() => import('./pages/EditInmueble/EditInmueble'));
// const Blog = lazy(() => import('./pages/Blog/Blog'));
// const Articulo = lazy(() => import('./pages/Articulo/Articulo'));
// const Servicios = lazy(() => import('./pages/Servicios/Servicios'));

function App() {
    const { t } = useTranslation();
    const [modal, setModal] = useState(false);
    const [toEquipo, setToEquipo] = useState(false);

    let botonModal = useRef();

    const openCloseModal = () => {
        setModal(!modal);
        botonModal.current.transform = "rotateZ(-90deg);";
    };
    //MENU
    // const body = (
    //   <div className="modal-burger">
    //     <div className="nav-links-burger">

    //       <a className='Link nav-link-burger' href='/serveis'>Serveis immobiliaris</a>

    //       <div className='line'></div>
    //       <div className='Link nav-link-burger' onClick={goToEquipo}>Equip</div>
    //       <div className='line'></div>
    //       <Link onClick={openCloseModal} className='Link nav-link-burger' to='/'>Blog</Link>
    //       <div className='line'></div>
    //     </div>

    //   </div >
    // );

    const burgerBtn = document.getElementById("burger-menu-link");
    const sideMenu = document.getElementById("side-burger-menu");

    function gotoEquipoNoResponsive() {
        try {
            const section = document.querySelector("#equipo-section-id");
            section.scrollIntoView({ behavior: "smooth", block: "center" });
        } catch (e) {
            goToHome().then(() => {
                const section = document.querySelector("#equipo-section-id");
                section.scrollIntoView({ behavior: "smooth", block: "center" });
            });
        }
    }

    function goToEquipo() {
        try {
            openCloseModal();
            const section = document.querySelector("#equipo-section-id");
            section.scrollIntoView({ behavior: "smooth", block: "center" });
        } catch (e) {
            openCloseModal();
            goToHome().then(() => {
                const section = document.querySelector("#equipo-section-id");
                section.scrollIntoView({ behavior: "smooth", block: "center" });
            });
        }
    }

    async function goToHome() {
        window.location.href = "/";
    }

    // useEffect(() => {
    //   ReactGA.pageview(window.location.pathname + window.location.search);
    // }, []);

    useEffect(() => {
        const isConsent = getCookieConsentValue();
        if (isConsent === "true") {
            ReactGA.initialize("G-MVR4Z36YWS");
        }
    }, []);

    return (
        <div className="App">
            <Router>
                <nav>
                    <div className="upper-nav">
                        <span className="span-upper-nav" id="direccion">
                            <a
                                style={{
                                    fontFamily: "Poppins",
                                    textDecoration: "none",
                                    color: "white",
                                }}
                                target="_blank"
                                href="https://www.google.es/maps/place/Ripoll%C3%A8s+Assessors+-+Ripoll/@42.193789,2.192897,17z/data=!3m1!4b1!4m6!3m5!1s0x12a53f73d1b3c79f:0x288cb39246e2ff1a!8m2!3d42.193789!4d2.192897!16s%2Fg%2F1q5bm577y?hl=es-419&entry=ttu&g_ep=EgoyMDI0MTEyNC4xIKXMDSoASAFQAw%3D%3D"
                            >
                                Carretera de Barcelona, 27 baixos - 17500 Ripoll
                            </a>
                        </span>
                        <span className="span-upper-nav" id="fuentes-contacto">
                            <a
                                style={{
                                    fontFamily: "Poppins",
                                    textDecoration: "none",
                                    color: "white",
                                    marginRight: "2px",
                                }}
                                href="tel:972 701 385"
                            >
                                972 701 385
                            </a>
                            |
                            <a
                                style={{
                                    fontFamily: "Poppins",
                                    textDecoration: "none",
                                    color: "white",
                                    marginLeft: "2px",
                                }}
                                href="mailto:info@ripollesassessors.cat"
                            >
                                info@ripollesassessors.cat
                            </a>
                        </span>
                        <span className="span-upper-nav" id="rrss">
                            {/* <a className='Link a' href="https://es-es.facebook.com/GarrotxaActiva/">
                <img className='icon-upper-nav' src={fbIcon} alt='icono Facebook' />
              </a> */}
                            <a
                                className="Link a"
                                href="https://www.instagram.com/ripollesassessors/"
                            >
                                <img
                                    className="icon-upper-nav"
                                    src={igIcon}
                                    alt="icono Instagram"
                                />
                            </a>
                            {/* <a className='Link a' href="https://twitter.com/garrotxaactiva">
                <img className='icon-upper-nav' src={twIcon} alt='icono Twitter' />
              </a>
              <a className='Link a' href="https://www.youtube.com/channel/UCduIKGnL0S6p3ay-bhRueyg">
                <img className='icon-upper-nav' src={ytIcon} alt='icono Youtube' />
              </a> */}
                        </span>
                    </div>
                    <div className="lower-nav">
                        <a className="Link a" id="logo-wrapper" href="/">
                            <img
                                id="logo-ga"
                                src={Logo}
                                alt="Logo Ripollès Assessors"
                            />
                        </a>

                        <div className="nav-links">
                            <a className="Link nav-link" href="/serveis/">
                                {t("Presentació")}
                            </a>
                            <a className="Link nav-link" href="/">
                                {t("Cercar immoble")}
                            </a>
                            <a className="Link nav-link" href="/vendre/">
                                {t("Vendre | Llogar")}
                            </a>
                            <a className="Link nav-link" href="/blog/">
                                {t("Blog")}
                            </a>
                        </div>

                        <div
                            ref={botonModal}
                            onClick={openCloseModal}
                            id="burger-menu-link"
                        >
                            <img
                                id="burger-menu-icon"
                                src={BurgerMenuIcon}
                                alt="icono menu "
                            />
                        </div>
                    </div>
                </nav>
                <Sidebar
                    onClose={() => {}}
                    onOpen={openCloseModal}
                    isOpen={modal}
                    onClickequipo={goToEquipo}
                />
                {/* <Modal
          id='side-burger-menu'
          BackdropProps={{ invisible: true, }}
          open={modal}
          onClose={openCloseModal}
          disableScrollLock
        >
          {body}
        </Modal> */}

                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/immobles/" element={<Inmuebles />} />
                    <Route path="/immoble/:id/" element={<DetallesInmb />} />
                    <Route path="/vendre/" element={<VenderPage />} />
                    <Route path="/portal/" element={<Login />} />
                    <Route path="/avis-legal/" element={<AvisLegal />} />
                    <Route
                        path="/politica-privacitat/"
                        element={<PoliticaPrivacidad />}
                    />
                    <Route
                        path="/politica-cookies/"
                        element={<PoliticaCookies />}
                    />
                    <Route element={<ProtectedRoutes />}>
                        <Route path="/home/" element={<Menu />} />
                        <Route path="/dashboard/" element={<DashboardInmb />} />
                        <Route
                            path="/pujar-immoble/"
                            element={<AddInmueble />}
                        />
                        <Route
                            path="/editar-immoble/:id/"
                            element={<EditInmueble />}
                        />
                    </Route>
                    <Route path="/blog/" element={<Blog />} />
                    <Route path="/blog/:id/" element={<Articulo />} />
                    <Route path="/serveis/" element={<Servicios />} />

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>

                <footer>
                    <Footer />
                </footer>

                <div className="logos-container">
                    <a href="https://www.cafgi.org/" target="blank">
                        <img
                            src={LAdminFC}
                            alt="logo Cafgi"
                            className="logos-img"
                        />
                    </a>
                    <a href="http://www.coleconomistes.cat/" target="blank">
                        {" "}
                        <img
                            src={LEconoCat}
                            alt="logo Coleconomistes"
                            className="logos-img"
                        />
                    </a>
                    <a href="https://www.apigirona.com/" target="blank">
                        {" "}
                        <img
                            src={LApi}
                            alt="logo API Girona"
                            className="logos-img"
                        />
                    </a>
                </div>
                <div style={{ zIndex: "10000 !important" }}>
                    <WhatsAppWidget
                        placeholder={t("Escriu un missatge...")}
                        sendButton={t("Enviar")}
                        textReplyTime={t("Sol respondre el mateix dia")}
                        message={t("Hola, què podem fer per tu?")}
                        companyName="Ona, de Ripollès Assessors"
                        phoneNumber="34659731933"
                    />
                </div>
            </Router>

            <CookieConsent
                enableDeclineButton="true"
                cookieName={CONSENT_COOKIE}
                // enableDeclineButton
                style={{
                    background: "#f6fbff",
                    color: "#000000",
                    padding: "20px",
                    paddingBottom: "75px",
                }}
                buttonStyle={{
                    background: "#022949",
                    color: "white",
                    fontWeight: "bolder",
                    borderRadius: "5px",
                }}
                declineButtonStyle={{
                    background: "#022949",
                    color: "white",
                    fontWeight: "bolder",
                    borderRadius: "5px",
                }}
                flipButtons
                buttonText={t("Acceptar i continuar navegant")}
                overlay
                declineButtonText={t("Rebutjar")}
                onAccept={() => {
                    acceptCookies();
                }}
                onDecline={() => {
                    declineCookies();
                }}
            >
                {t(
                    "Utilitzem  cookies pròpies i de tercers per al correcte funcionament del lloc web, i si ens dona el seu consentiment,  també farem servir cookies per recopilar dades de les seves visites per obtenir estadístiques agregades per millorar els nostres serveis."
                )}
                <div style={{ marginTop: "20px" }}>
                    {t("Premi per obtenir")}{" "}
                    <a href="/politica-cookies/" style={{ fontWeight: "700" }}>
                        {t("més informació")}
                    </a>
                    .
                </div>
                {/* {t('o per')} <a href=""  style={{ fontWeight: '700' }} >{t("rebutjar-ne")}</a> {t("l'ús")} */}
            </CookieConsent>
        </div>
    );
}

export default App;
